import { f as r } from "./fails.js";
import { g as a } from "./global.js";
var e = a.RegExp,
  o = r(function () {
    var r = e("(?<a>b)", "g");
    return "b" !== r.exec("b").groups.a || "bc" !== "b".replace(r, "$<a>c");
  });
export { o as r };